var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-8 flex items-center"},[(_vm.title && _vm.showWidgetTitle)?_c('p',{staticClass:"font-semibold truncate widget-header-title",class:{ 'widget-title': !_vm.customFontSize },style:(_vm.customFontSize)},[_vm._t("default",function(){return [_vm._v("\n            "+_vm._s(_vm.$t(_vm.title))+"\n        ")]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }